import * as Sentry from '@sentry/vue'

import { useUser } from '@/Composables/spaceship'

/**
 * Opens the Sentry feedback form configured in app.ts ("Bug melden").
 *
 * Name and email are on the Sentry scope only while the form is open. Everything else
 * Sentry captures — errors, transactions, replays — carries the user id alone, which is
 * enough to resolve the person against our own database.
 */
export async function openBugReport(): Promise<void> {
  const user = useUser()
  const restoreUser = (): void => {
    Sentry.setUser({ id: user.value?.id })
  }

  Sentry.setUser({
    id: user.value?.id,
    email: user.value?.email,
    username: user.value?.name,
  })

  const feedback = Sentry.getFeedback()
  const form = await feedback?.createForm({
    useSentryUser: { email: 'email', name: 'username' },
    onFormClose: restoreUser,
    onFormSubmitted: restoreUser,
  })

  if (form === undefined) {
    restoreUser()

    return
  }

  form.appendToDom()
  form.open()
}
